import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'

@jsonClass('Tenant')
export class Tenant {
	@jsonProperty(String) id!: string
	@jsonProperty(String) name?: string
	@jsonProperty(String) parentId?: string

	constructor(init?: Partial<Tenant>) {
		assignCommonProperties(this, init)
	}
}
